import { render, staticRenderFns } from "./CustomerApplicationsView.vue?vue&type=template&id=ecfd57e0&"
import script from "./CustomerApplicationsView.vue?vue&type=script&lang=js&"
export * from "./CustomerApplicationsView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerApplicationsView.vue?vue&type=style&index=0&id=ecfd57e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports